module.exports = __webpack_public_path__ + "static/img/img6.64eecc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/img6.png
// module id = WM0o
// module chunks = 1